export const AnimationConstants = {
  modal: 400,
  dropdown: 200,
  popup: 200,
  accordion: 350,
};
